var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCiCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_213_26)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_213_26",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 24H24V64H64V24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_213_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9798 39.6477L60.0634 39.0646C59.7426 38.001 59.3173 36.9742 58.7935 35.9976L60.4429 33.5234C60.7529 33.0586 60.6917 32.4397 60.2966 32.0448L55.8772 27.6253C55.4822 27.2303 54.8633 27.1691 54.3985 27.4788L51.9242 29.1283C50.9477 28.6045 49.9208 28.1794 48.8573 27.8584L48.2741 24.942C48.1646 24.3943 47.6836 24 47.125 24H40.875C40.3164 24 39.8354 24.3943 39.7258 24.942L39.1427 27.8584C38.0791 28.1794 37.0522 28.6046 36.0757 29.1283L33.6014 27.4788C33.1367 27.1691 32.5177 27.2303 32.1227 27.6253L27.7034 32.0448C27.3083 32.4398 27.247 33.0587 27.557 33.5234L29.2064 35.9976C28.6826 36.9742 28.2574 38.001 27.9365 39.0646L25.0202 39.6477C24.4724 39.7573 24.0781 40.2383 24.0781 40.7969V47.0469C24.0781 47.6054 24.4724 48.0865 25.0202 48.1959L27.9366 48.7792C28.2574 49.8427 28.6827 50.8696 29.2065 51.8461L27.557 54.3203C27.2471 54.7851 27.3084 55.404 27.7034 55.799L32.1228 60.2184C32.5179 60.6134 33.1367 60.6747 33.6015 60.3648L36.0251 58.7492V51.3926C34.1898 49.4391 33.0625 46.8144 33.0625 43.9219C33.0625 37.8813 37.9594 32.9844 44 32.9844C50.0406 32.9844 54.9375 37.8813 54.9375 43.9219C54.9375 46.8144 53.8102 49.4391 51.9749 51.3926V58.7492L54.3985 60.3648C54.5968 60.4971 54.8231 60.5617 55.0481 60.5617C55.3506 60.5617 55.6507 60.4449 55.8771 60.2184L60.2965 55.7991C60.6915 55.4041 60.7528 54.7852 60.4429 54.3204L58.7934 51.8462C59.3173 50.8696 59.7424 49.8427 60.0633 48.7793L62.9797 48.196C63.5276 48.0865 63.9219 47.6054 63.9219 47.0469V40.7969C63.9219 40.2383 63.5275 39.7573 62.9798 39.6477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7125 37.5007C47.1227 37.1591 46.3744 37.5216 46.277 38.1961L45.5625 43.1405H42.4375L41.7231 38.1961C41.6256 37.5216 40.8775 37.1591 40.2877 37.5007C37.9995 38.8261 36.5781 41.2866 36.5781 43.9217C36.5781 46.7773 38.1773 49.3319 40.7517 50.5883L40.875 50.6486V62.828C40.875 63.4752 41.3997 63.9998 42.0469 63.9998H45.9531C46.6003 63.9998 47.125 63.4752 47.125 62.828V50.6486L47.2483 50.5883C49.8227 49.3319 51.4219 46.7773 51.4219 43.9217C51.4219 41.2866 50.0006 38.8261 47.7125 37.5007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_213_26",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiCd);
export default __webpack_public_path__ + "static/media/ci-cd.36edb97a30184b1d162ca5151c2d53e6.svg";
export { ForwardRef as ReactComponent };